import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Lib
import { PENDO_CLASS_REPORTS_DOWNLOAD_REPORT } from '@/lib/tools/pendo/class';

// Components
import Icon from '@/components/base/Icon';
import Loader from '@/components/base/Loader';
import Tooltip from '@/components/base/Tooltip';

const ActionsDownloadCell = ({ cell }) => {
    const { t } = useTranslation('reports');

    if (cell?.row?.original?.state === 'pending' || cell?.row?.original?.state === 'ongoing') {
        return (
            <div className="flex justify-center space-x-5">
                <Loader className="h-4 w-4 text-icoGray-400 dark:text-icoDarkMode-wolf" />
                <Tooltip content={t('general.report_generation_pending')} placement="top">
                    <Icon icon="clock" className="text-icoYellow dark:text-icoDarkMode-yellow" />
                </Tooltip>
            </div>
        );
    }

    if (cell?.row?.original?.state === 'failed') {
        return (
            <div className="flex justify-center">
                <Tooltip content={t('general.report_generation_errors')} placement="top">
                    <Icon icon="warning" className="text-icoRed" />
                </Tooltip>
            </div>
        );
    }

    return (
        <div className="flex justify-center space-x-1">
            <a
                className={clsx('cursor-pointer', PENDO_CLASS_REPORTS_DOWNLOAD_REPORT)}
                href={cell?.row?.original?.url ?? null}
                target={cell?.row?.original?.format !== 'pdf' ? '_self' : '_blank'}
                download
                rel="noopener noreferrer"
                title={t('commons:download')}>
                <Icon
                    icon="export"
                    className="text-icoGray-500 hover:text-icoBlue dark:text-icoDarkMode-wolf dark:hover:text-icoBlue"
                />
            </a>
        </div>
    );
};

ActionsDownloadCell.propTypes = {
    cell: PropTypes.object.isRequired
};

export default ActionsDownloadCell;
